import { render, staticRenderFns } from "./OperationAdvertising.vue?vue&type=template&id=f66dba08&scoped=true"
import script from "./OperationAdvertising.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperationAdvertising.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./OperationAdvertising.vue?vue&type=style&index=0&id=f66dba08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66dba08",
  null
  
)

export default component.exports